import React from "react";
import "./StepProgressBar.css";

function StepProgressBar({ progress = 34 }) {
  return (
    <div className="step-progress-parent">
      <div className="step-progress-container">
        {/* Background Line */}
        <div className="progress-line-bg">
          <div
            className="progress-line-fill"
            style={{ "--progress": `${progress}%` }}
          />
        </div>

        {/* Steps */}
        <div className="steps-wrapper">
          <div className="step-item">
            <span className="step-dot sky_blue"></span>
            <p className="step-text">Submitted</p>
          </div>

          <div className="step-item">
            <span className="step-dot yellow"></span>
            <p className="step-text">Under Review</p>
          </div>

          <div className="step-item">
            <span className="step-dot blue"></span>
            <p className="step-text">Payment</p>
          </div>

          <div className="step-item">
            <span className="step-dot green"></span>
            <p className="step-text">Accepted</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StepProgressBar;
